export default __webpack_public_path__ + "static/media/bg_bussines.1139ac4e.svg";